import React from 'react';
import {Routes, Navigate, Route} from 'react-router-dom';
import Dashboard from './pages/dashboard/Dashboard';
import RoleEditor from './pages/roleEditor/RoleEditor';
import ListUsers from './pages/user/listUser/ListUsers';
import UserManagement from './pages/UserManagement/userManagement';
import AddNewUser from './pages/user/addNewUser/AddNewUser';
import UpdateUser from './pages/user/updateUser/UpdateUser';
import UserDetails from './pages/user/userDetails/UserDetails';
import Credential from './pages/credential/Credential';
import Publish from './pages/publish/Publish';
import CredentialForm from './pages/credential/CredentialForm/CredentialForm';
import Market from './pages/market/Market';
import AutomDetails from './pages/automStore/automDetails/AutomDetails';
import AutomList from './pages/automs/automs';
import NewAutom from './pages/automs/NewAutom/newAutom'
import MatesList from './pages/myMates/MatesList/MatesList';
import MatesDetail from './pages/myMates/mateDetail/MateDetail';
import {removeFlowFromStorage} from '../helpers/historyHandler';
import MonitoringIndex from "./pages/monitoring/MonitoringIndex";
import Settings from './pages/settings/settings';
import GeneralSettings from './pages/settings/general/General';
import Personalization from './pages/settings/personalization/Personalization';
import PortSettings from './pages/settings/port/Port';
import UpdateSettings from './pages/settings/updates/Updates';
import MonitoringDetails from "./pages/monitoring/monitoringDetails/MonitoringDetails";
import AiLab from "./pages/ailab/AiLab";
import Orchestrator from "./pages/Orchestrator/orchestrator";
import Vault from "./pages/Vault/vault";
import WebhookAPI from "./pages/WebhookAPI/webhookApi";
import Libraries from './pages/Libraries/Libraries';
import LibraryDetail from "./pages/Libraries/LibraryDetail/LibraryDetail";
import MailServer from './pages/settings/mailServer/MailServer';
import License from './pages/settings/License/License';
import {useRecoilValue} from 'recoil';
import {rolePermission, licensePermission} from '../recoil-store/recoil-state';
import Variants from './pages/variants/Variants';
import Integrations from './pages/integrations/Integrations';
import QueuePool from './pages/queue/QueuePool';
import GlobalAnnouncementList from './pages/globalAnnouncement/GlobalAnnouncementList';
import GlobalAnnouncementForm from './pages/globalAnnouncement/GlobalAnnouncementForm';
import Alerts from './pages/alert/AlertManagement';
import AlertManagement from './pages/AlertManagement/alertManagement';
import AlertProfile from './pages/alert/AlertProfile';
import WebhookRule from './pages/webhookRule/WebhookRule';
import ActioneerProfile from './pages/actioneerProfile/ActioneerProfile';
import AppCredentials from './pages/appCredential/listAppCredential/ListAppCredential';
import LibraryStore from './pages/LibraryStore/libraryStore';

function Home({asm}) {
    const permissions = useRecoilValue(rolePermission)
    const license = useRecoilValue(licensePermission);

    if (window.location.pathname !== '/Automs') {
        removeFlowFromStorage('flow')
        removeFlowFromStorage('process')
        localStorage.removeItem('tabs');
        localStorage.removeItem('diagram');
        removeFlowFromStorage('stopAction');
    }

    return (
        <Routes>
            <Route path="/dashboard" element={<Dashboard/>}/>
            <Route path="/" element={<Dashboard/>}/>
            {permissions?.data?.includes('APPCREDENTIALS_VIEW') &&
            <Route path='/management/vault/app-credentials' element={<Vault directTo={<AppCredentials/>}/>}/>}
            {permissions?.data?.includes('ROLEMAGEMENT_VIEW') &&
            <Route path='/management/user-management/roles'
                   element={<UserManagement asm={asm} directTo={<RoleEditor/>}/>}/>}
            {permissions?.data?.includes('USERMANAGEMENT_VIEW') &&
            <Route path='/management/user-management' element={<UserManagement asm={asm} directTo={<ListUsers/>}/>}/>}
            {permissions?.data?.includes('USERMANAGEMENT_VIEW') &&
            <Route path='/management/user-management/users'
                   element={<UserManagement asm={asm} directTo={<ListUsers/>}/>}/>}
            {permissions?.data?.includes('USERMANAGEMENT_CREATE') &&
            <Route path='/management/user-management/users/new'
                   element={<UserManagement asm={asm} directTo={<AddNewUser/>}/>}/>}
            {permissions?.data?.includes('USERMANAGEMENT_VIEW') &&
            <Route path='/management/user-management/users/:id'
                   element={<UserManagement asm={asm} directTo={<UserDetails/>}/>}/>}
            {permissions?.data?.includes('USERMANAGEMENT_UPDATE') &&
            <Route path='/management/user-management/users/:id/edit'
                   element={<UserManagement asm={asm} directTo={<UpdateUser/>}/>}/>}
            {permissions?.data?.includes('CONNECTION_VIEW') &&
            <Route path='/management/vault/custom-credentials' element={<Vault asm={asm} directTo={<Credential/>}/>}/>}
            {permissions?.data?.includes('CONNECTION_CREATE') &&
            <Route path='/management/vault/custom-credentials/new'
                   element={<Vault asm={asm} directTo={<CredentialForm/>}/>}/>}
            {permissions?.data?.includes('CONNECTION_UPDATE') &&
            <Route path='/management/vault/custom-credentials/:id/edit'
                   element={<Vault directTo={<CredentialForm/>}/>}/>}
            {permissions?.data?.includes('AUTOMSTORE_VIEW') &&
            <Route path='/store/autom' element={<Market/>}/>}
            {permissions?.data?.includes('LIBRARYSTORE_VIEW') &&
            <Route path='/store/library/:id' element={<LibraryDetail/>}/>}
            {permissions?.data?.includes('LIBRARYSTORE_VIEW') &&
            <Route path='/store/library' element={<LibraryStore/>}/>}
            {permissions?.data?.includes('AUTOMSTORE_VIEW') &&
            <Route exact path='/store/variants' element={<Variants/>}/>}
            {/*{permissions?.data?.includes('AUTOMSTORE_VIEW') &&*/}
            {/*<Route exact path='/environments' element={<Integrations/>}/>}*/}
            {permissions?.data?.includes('AUTOMSTORE_VIEW') &&
            <Route exact path='/store/autom/:id' element={<AutomDetails/>}/>}
            {permissions?.data?.includes('CUSTOMAUTOMS_VIEW') && license?.data?.flow_designer &&
            <Route path='/my-environment/autom-list' element={<AutomList/>}/>}
            {permissions?.data?.includes('CUSTOMAUTOMS_CREATE') && license?.data?.flow_designer &&
            <Route path='/autom-new' element={<NewAutom typeId="071158d5-c781-42d0-a161-448aec7f9b4c"/>}/>}
            {permissions?.data?.includes('CUSTOMAUTOMS_CREATE') && license?.data?.flow_designer &&
            <Route path='/action-new' element={<NewAutom typeId="c45bede2-30e3-4b67-aa65-6e06621a9e05"/>}/>}
            {permissions?.data?.includes('MYMATES_VIEW') &&
            <Route path='/my-environment/my-mates' element={<MatesList/>}/>}
            {permissions?.data?.includes('MYMATES_CREATE') &&
            <Route path='/my-environment/my-mates/new' element={<MatesDetail/>}/>}
            {permissions?.data?.includes('MYMATES_VIEW') &&
            <Route path='/my-environment/my-mates/:id' element={<MatesDetail/>}/>}
            {permissions?.data?.includes('MONITORING_VIEW') &&
            <Route path='/dashboard/monitoring' element={<MonitoringIndex/>}/>}
            {permissions?.data?.includes('MONITORING_VIEW') &&
            <Route path='/dashboard/monitoring/:id' element={<MonitoringDetails/>}/>}
            {permissions?.data?.includes('VAULT_VIEW') &&
            <Route path='/management/vault' element={<Vault asm={asm} directTo={<AppCredentials/>}/>}/>}
            {permissions?.data?.includes('QUEUEPOOL_VIEW') &&
            <Route path='/management/queue-pool' element={<QueuePool/>}/>}
            {permissions?.data?.includes('GLOBALANNOUNCEMENT_VIEW') &&
            <Route path='/management/global-announcement' element={<GlobalAnnouncementList/>}/>}
            {permissions?.data?.includes('GLOBALANNOUNCEMENT_CREATE') &&
            <Route path='/management/global-announcement/new' element={<GlobalAnnouncementForm/>}/>}
            {(permissions?.data?.includes('GLOBALANNOUNCEMENT_UPDATE') || permissions?.data?.includes('GLOBALANNOUNCEMENT_VIEW')) &&
            <Route path='/management/global-announcement/:id/edit' element={<GlobalAnnouncementForm/>}/>}
            {permissions?.data?.includes('ALERTMANAGEMENT_VIEW') &&
            <Route path='/dashboard/alerts' element={<Alerts/>}/>}
            {permissions?.data?.includes('ALERTMANAGEMENT_VIEW') &&
            <Route path='/management/alert-management'
                   element={<AlertManagement asm={asm} directTo={<AlertProfile/>}/>}/>}
            {permissions?.data?.includes('ALERTPROFILE_VIEW') &&
            <Route path='/management/alert-management/alert-profile'
                   element={<AlertManagement asm={asm} directTo={<AlertProfile/>}/>}/>}
            {permissions?.data?.includes('WEBHOOKAPITRIGGERRULE_VIEW') &&
            <Route path='/management/webhook-api' element={<WebhookAPI asm={asm} directTo={<WebhookRule/>}/>}/>}
            {permissions?.data?.includes('WEBHOOKAPITRIGGERRULE_VIEW') &&
            <Route path='/management/webhook-api/webhook-trigger-rule'
                   element={<WebhookAPI asm={asm} directTo={<WebhookRule/>}/>}/>}
            {permissions?.data?.includes('ACTIONEERPROFILE_VIEW') &&
            <Route path='/management/alert-management/actioneer-profile'
                   element={<AlertManagement asm={asm} directTo={<ActioneerProfile/>}/>}/>}
            {permissions?.data?.includes('ORCHESTRATOR_VIEW') &&
            <Route path='/my-environment/orchestrator' element={<Orchestrator/>}/>}
            {permissions?.data?.includes('LIBRARIES_VIEW') &&
            <Route path='/my-environment/libraries' element={<Libraries/>}/>}
            {permissions?.data?.includes('LIBRARIES_VIEW') &&
            <Route path='/my-environment/libraries/:id' element={<LibraryDetail/>}/>}
            {permissions?.data?.includes('GLOBALVALUES_VIEW') &&
            <Route path='/global-values' element={<Dashboard/>}/>}
            {permissions?.data?.includes('SETTINGS_VIEW') &&
            <Route path='/settings' element={<Settings asm={asm} directTo={<GeneralSettings/>}/>}/>}
            {permissions?.data?.includes('SETTINGS_VIEW') &&
            <Route path='/settings/general' element={<Settings asm={asm} directTo={<GeneralSettings/>}/>}/>}
            {permissions?.data?.includes('PERSONALIZATIONMANAGEMENT_VIEW') &&
            <Route path='/settings/personalization' element={<Settings asm={asm} directTo={<Personalization/>}/>}/>}
            {permissions?.data?.includes('PORTMANAGEMENT_VIEW') &&
            <Route path='/settings/port' element={<Settings asm={asm} directTo={<PortSettings/>}/>}/>}
            {permissions?.data?.includes('MAILSERVERMANAGEMENT_VIEW') &&
            <Route path='/settings/mail-server' element={<Settings asm={asm} directTo={<MailServer/>}/>}/>}
            {permissions?.data?.includes('UPDATEMANAGEMENT_VIEW') &&
            <Route path='/settings/updates' element={<Settings asm={asm} directTo={<UpdateSettings/>}/>}/>}
            {permissions?.data?.includes('APPROVEMENTS_VIEW') &&
            <Route path='/management/approvements' element={<Publish type="bot"/>}/>}
            {permissions?.data?.includes('LICENSEMANAGEMENT_VIEW') &&
            <Route path='/settings/license' element={<Settings asm={asm} directTo={<License/>}/>}/>}
            {permissions?.data?.includes('SETTINGS_VIEW') &&
            <Route path='/ai-lab' element={<AiLab/>}/>}
            <Route path="*" element={<Navigate to="/404"/>}/>
        </Routes>
    );
}

export default Home;
